import { SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'

const UNBLOCKED_ADDITIONAL_SALE_DATA = {
  createdInDatabase: false,
  actionsInProgress: false,
  state: '',
  statusCode: '',
  status: '',
  attributes: null,
  infoAttributes: null,
  code_status: null,
  document_status: null,
  passcode_required: null,
  passcode_set_at: null,
  zohoOpportunityId: null,
  zohoContractId: null,
  zohoContractDetailId: null,
  saleDatabaseId: null,
  createdBy: null,
}

export const unblockAdditionalSale = ({ saleType, updateLead, showNotification, t }) => {
  updateLead(UNBLOCKED_ADDITIONAL_SALE_DATA, saleType)
  showNotification({
    type: SNACKBAR_TYPES.SUCCESS,
    message: t('additionalSales:common.zoho_abandon_detected'),
  })
}
